import React, { useMemo } from "react";
import { View } from "react-native";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { ColorTokens, DividerSizeTokens, IconTokens } from "@voltmoney/schema";
import Divider from "../../divider/Divider";
import AboutUsScreenContent from "./AboutUsScreenContent";
const AboutUsScreen = ({ height, backAction, privacyAction, termsAction, lendingPartnerAction, productDetailAction, triggerAction, }) => {
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'About us', goBackAction: backAction, hideNeedHelp: true, triggerAction: triggerAction }));
    }, []);
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16 } },
            React.createElement(AboutUsScreenContent, { icon: IconTokens.File, label: 'Terms of service', action: termsAction, triggerAction: triggerAction }),
            React.createElement(View, { style: { marginTop: 20, marginBottom: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(AboutUsScreenContent, { icon: IconTokens.Locked, label: 'Privacy policy', action: privacyAction, triggerAction: triggerAction }),
            React.createElement(View, { style: { marginTop: 20, marginBottom: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(AboutUsScreenContent, { icon: IconTokens.SYSTEM_INVESTOR_DLS, label: 'Lending partners', action: lendingPartnerAction, triggerAction: triggerAction }),
            React.createElement(View, { style: { marginTop: 20, marginBottom: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(AboutUsScreenContent, { icon: IconTokens.SYSTEM_INFO_DLS, label: 'Product details', action: productDetailAction, triggerAction: triggerAction }),
            React.createElement(View, { style: { marginTop: 20, marginBottom: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.White },
        React.createElement(React.Fragment, null, renderContent())));
};
export default AboutUsScreen;
